"use strict";
var $dyn;
(function ($dyn) {
    /**
     * Get the data context associated with the target element.
     * @param targetElement The data bound element
     * @returns The data context (usually a $dyn.ui.Control)
     */
    function context(targetElement) {
        if (targetElement) {
            // tslint:disable-next-line:no-shadowed-variable
            var context_1 = targetElement.dynContext;
            return context_1 ? context_1.current : undefined;
        }
    }
    $dyn.context = context;
    /**
     * Gets the value of a data context
     */
    function contextValue(dataContext) {
        return dataContext instanceof $dyn.DataContext ? dataContext.current : dataContext;
    }
    $dyn.contextValue = contextValue;
    /**
     * @deprecated
     */
    function rootContext(targetElement) {
        $dyn.logDeprecated("$dyn.rootContext");
        // Marked as deprecated as no consumers were found for this internal method.
        // tslint:disable-next-line:no-shadowed-variable
        var context = targetElement.dynContext;
        if (!context || !context.scopeVars) {
            return;
        }
        return context.scopeVars.$root;
    }
    $dyn.rootContext = rootContext;
    function rootElement(targetElement) {
        // tslint:disable-next-line:no-shadowed-variable
        var context = targetElement.dynContext;
        if (!context || !context.scopeVars) {
            throw TypeError("Can not get the root of element that is not data bound.");
        }
        return context.scopeVars.$root && context.scopeVars.$root.element;
    }
    $dyn.rootElement = rootElement;
    /**
     * Unwraps a context.
     */
    function _contextValue(obj) {
        return obj instanceof $dyn.DataContext ? obj.current : obj;
    }
    $dyn._contextValue = _contextValue;
    /**
     * Evaluates and returns the new data-context based on the given parent data-context
     * @description If a data-context expression is not provided on the element, the parentDataContext will be returned.
     */
    function evalDataContext(targetElement, parentDataContext, contextAttribute) {
        // Given data-context could be an external object, or one of our previously evaluated context
        // If it is not previously evaluated context, we need to normalize it first to a wrapper
        if (!(parentDataContext instanceof $dyn.DataContext)) {
            parentDataContext = new $dyn.DataContext(parentDataContext, undefined);
        }
        var evaluator = $dyn._parseDataContext(targetElement, contextAttribute);
        if (evaluator) {
            // Evaluate the new data-context, and return in a new wrapper
            // tslint:disable-next-line:no-shadowed-variable
            var context_2 = new $dyn.DataContext(evaluator(parentDataContext, targetElement), parentDataContext);
            if ($dyn.debug.binding) {
                context_2.expression = targetElement.getAttribute("data-dyn-context");
            }
            targetElement[contextAttribute] = context_2;
            return context_2;
        }
        else {
            return parentDataContext;
        }
    }
    $dyn.evalDataContext = evalDataContext;
    /**
     * Parses and gets the data-context evaluator associated with the node.
     * @description Parses and gets the data-context evaluator associated with the node as a function that can be executed by passing in
     * parent data-context. If no data-context attribute exists, this returns null. This method caches the parsed data-context
     * evaluator as an invokable function on the element's data.
     */
    function _parseDataContext(targetElement, contextAttribute) {
        var evaluator;
        var dataContextAttr = targetElement.getAttribute(contextAttribute);
        if (dataContextAttr) {
            // Create the eval-able expression from the binding expression
            evaluator = $dyn._parseBindingExpression(dataContextAttr);
        }
        else {
            evaluator = null;
        }
        return evaluator;
    }
    $dyn._parseDataContext = _parseDataContext;
    /**
     * Evaluates and returns the binding values based on a given data-context.
     * @description If a data-bind expression is not provided on the element, this will return undefined.
     */
    function evalDataBinding(targetElement, dataContext) {
        var evaluator = $dyn._parseDataBinding(targetElement);
        if (evaluator) {
            var dataContextWrapper = dataContext instanceof $dyn.DataContext ? dataContext : new $dyn.DataContext(dataContext);
            return evaluator(dataContextWrapper, targetElement);
        }
    }
    $dyn.evalDataBinding = evalDataBinding;
    /**
     * The data-context wrapper for a control.
     * @description Creates a data-context wrapper given a new object to be used as the $data, and an optional parent data context wrapper
     */
    var DataContext = /** @class */ (function () {
        /**
         * Constructor for DataContext class
         * @param data The data (usually the $dyn.ui.Control)
         * @param parentContext The parent data context wrapper.
         */
        function DataContext(data, parentContext) {
            if (parentContext && !(parentContext instanceof $dyn.DataContext)) {
                parentContext = new $dyn.DataContext(parentContext);
            }
            /**
             * The current data context
             */
            // TODO: Should we just use data?
            this.current = (data === undefined) ? null : data;
            /**
             * The parent data context
             */
            this.parentContext = parentContext;
            this.scopeVars = parentContext ? Object.create(parentContext.scopeVars) : {};
        }
        DataContext.prototype.parent = function (offset) {
            if (!this.parentContext) {
                return {};
            }
            else if (offset === undefined || offset === 0) {
                return this.parentContext.current;
            }
            else {
                return this.parentContext.parent(offset - 1);
            }
        };
        return DataContext;
    }());
    $dyn.DataContext = DataContext;
})($dyn || ($dyn = {}));

//# sourceMappingURL=DataContext.js.map
